/* ProductMediaGallery — gambar produk + (opsional) SATU video produk induk.
   Video tidak pernah autoplay, tanpa paksa suara; poster = gambar utama produk. */
import React, { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { imageUrl } from "@/lib/api";

export default function ProductMediaGallery({ images = [], video, displayedImgIdx, onSelectImage, name, badge }) {
  const videoUrl = video?.url ? imageUrl(video.url) : "";
  const [showVideo, setShowVideo] = useState(false);
  const poster = images[0] ? imageUrl(images[0]) : undefined;

  // Pergantian varian mengganti gambar (image_index) → kembali ke tampilan gambar.
  useEffect(() => { setShowVideo(false); }, [displayedImgIdx]);
  // Video dihapus → jangan tinggalkan player kosong; produk tanpa gambar → video jadi tampilan utama.
  useEffect(() => { setShowVideo(!!videoUrl && images.length === 0); }, [videoUrl, images.length]);

  const hasThumbs = images.length > 1 || (!!videoUrl && images.length > 0);

  return (
    <div data-testid="product-media-gallery">
      <div className="aspect-square bg-white rounded-3xl border border-[#E5E5E5] overflow-hidden relative" data-testid="product-main-image">
        {showVideo && videoUrl ? (
          <video
            key={videoUrl}
            src={videoUrl}
            poster={poster}
            controls
            playsInline
            preload="metadata"
            className="w-full h-full object-contain bg-black"
            data-testid="product-video-player"
          >
            Browser Anda tidak mendukung pemutaran video.
          </video>
        ) : images[displayedImgIdx] ? (
          <img src={imageUrl(images[displayedImgIdx])} alt={name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full grid place-items-center text-[#E5E5E5]">No image</div>
        )}
        {!showVideo && badge}
      </div>

      {hasThumbs && (
        <div className="mt-3 flex gap-2 overflow-x-auto no-scrollbar" data-testid="product-media-thumbs">
          {images.map((img, i) => (
            <button
              key={`${img}-${i}`}
              type="button"
              onClick={() => { setShowVideo(false); onSelectImage(i); }}
              className={`shrink-0 w-20 h-20 rounded-xl overflow-hidden border-2 ${
                !showVideo && displayedImgIdx === i ? "brand-border-primary" : "border-[#E5E5E5]"
              }`}
              data-testid={`product-thumb-${i}`}
            >
              <img src={imageUrl(img)} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
          {videoUrl && (
            <button
              type="button"
              onClick={() => setShowVideo(true)}
              aria-label="Putar video produk"
              className={`shrink-0 w-20 h-20 rounded-xl overflow-hidden border-2 relative bg-black ${
                showVideo ? "brand-border-primary" : "border-[#E5E5E5]"
              }`}
              data-testid="product-thumb-video"
            >
              {poster && <img src={poster} alt="" className="w-full h-full object-cover opacity-60" />}
              <span className="absolute inset-0 grid place-items-center">
                <span className="w-9 h-9 rounded-full bg-white/90 grid place-items-center shadow">
                  <Play size={16} className="text-black ml-0.5" fill="currentColor" />
                </span>
              </span>
            </button>
          )}
        </div>
      )}
    </div>
  );
}
